import { StringUtils } from 'src/app/services/utils/string.utils';

export class ClientPropertiesObject {

    constructor(private clientId: string, private passport: string, private name: string) {
    }

    public static create(): ClientPropertiesObject {
        return new ClientPropertiesObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
    }

    public getClientId() {
        return this.clientId;
    }

    public getPassport() {
        return this.passport;
    }

    public getName() {
        return this.name;
    }
}
